export default __webpack_public_path__ + "static/media/abc4.7da10619.jpg";